module.exports = __webpack_public_path__ + "img/c07_unitstartechraiderchampion_Normal_ua.1ca39260.webp";